import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../environments/environment";
import { Reportefalla } from "../../models/reportefalla.model";
import { CommonResponse } from "../../response/common.response";

export const RESPONSABLES_ATENCION = [
  'Leonardo Rivas',
  'William Flores',
  'Gabriel Escarate',
  'Manuel Oberto',
];

const SEDE_RESPONSABLE_CHAVIMOCHIC = {
  2: 'Leonardo Rivas',  // CALLAO
  1: 'Leonardo Rivas',  // AREQUIPA
  8: 'Leonardo Rivas',  // TACNA
  6: 'Leonardo Rivas',  // PISCO
  7: 'William Flores',  // SALAVERRY
  4: 'William Flores',  // CHIMBOTE
  5: 'Gabriel Escarate', // PAITA
  10: 'Gabriel Escarate', // TUMBES
  3: 'Gabriel Escarate',  // CHICLAYO
};

const EMPRESA_ID_CHAVIMOCHIC = '1';
const EMPRESA_ID_ITURRI_AP = '2';
const EMPRESA_ID_ITURRI_AC = '3';
const EMPRESA_ID_SMARTBOTS = '4';

@Component({
  selector: 'app-falla-modal',
  templateUrl: './falla-modal.component.html',
  styleUrls: ['./falla-modal.component.scss'],
})
export class FallaModalComponent implements OnInit {
  HTTP_RESPONSE = environment.HTTP_RESPONSE;
  dialogTitle: string;
  trabajador: any;
  movilList: any[] = [];
  tipoEquipoList: any[] = [];
  responsablesList = RESPONSABLES_ATENCION;
  guardando = false;
  cargandoHistorial = false;
  historialList: any[] = [];

  fallaForm: FormGroup = new FormGroup({
    reportefalla_tipoequipo: new FormControl(null, Validators.required),
    reportefalla_serie: new FormControl({value: '', disabled: true}),
    reportefalla_descripcionequipo: new FormControl({value: '', disabled: true}),
    reportefalla_sede: new FormControl({value: '', disabled: true}),
    reportefalla_usuario: new FormControl({value: '', disabled: true}),
    reportefalla_descripcionfalla: new FormControl('', Validators.required),
    reportefalla_actividadrealizada: new FormControl('', Validators.required),
    reportefalla_responsable: new FormControl(null, Validators.required),
  });

  constructor(
    public dialogRef: MatDialogRef<FallaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastService: ToastrService,
    private reportefallaService: Reportefalla,
  ) {
    this.trabajador = data.trabajador;
    this.movilList = data.movilList || [];
    this.dialogTitle = this.trabajador.trabajador_nombrescompletos;

    if (this.trabajador.computadora_trabajador && this.trabajador.computadora_trabajador.computadora_id > 0) {
      this.tipoEquipoList.push({value: 'LAPTOP', label: 'Laptop / Computadora'});
    }
    if (this.trabajador.telefono_trabajador && this.trabajador.telefono_trabajador.telefono_id > 0) {
      this.tipoEquipoList.push({value: 'CELULAR', label: 'Celular'});
    }

    this.fallaForm.controls.reportefalla_sede.setValue(this.trabajador.sede);
    this.fallaForm.controls.reportefalla_usuario.setValue(
      (this.trabajador.trabajador_apellidos + ' ' + this.trabajador.trabajador_nombres).trim()
    );

    if (this.tipoEquipoList.length === 1) {
      this.fallaForm.controls.reportefalla_tipoequipo.setValue(this.tipoEquipoList[0].value);
      this.cambiarTipoEquipo();
    }

    this.sugerirResponsable();
  }

  ngOnInit() {
    this.cargarHistorial();
  }

  cargarHistorial() {
    this.cargandoHistorial = true;
    this.reportefallaService.getByTrabajadorID(this.trabajador.trabajador_id).then((response: CommonResponse) => {
      this.cargandoHistorial = false;
      if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
        // @ts-ignore
        this.historialList = response.data;
      }
    });
  }

  cambiarTipoEquipo() {
    const tipo = this.fallaForm.controls.reportefalla_tipoequipo.value;
    if (tipo === 'LAPTOP') {
      const computadora = this.trabajador.computadora_trabajador;
      this.fallaForm.controls.reportefalla_serie.setValue(computadora.computadora_serial);
      this.fallaForm.controls.reportefalla_descripcionequipo.setValue(
        (computadora.computadora_marcatext + ' ' + computadora.computadora_modelotext).trim()
      );
    } else if (tipo === 'CELULAR') {
      const telefono = this.trabajador.telefono_trabajador;
      this.fallaForm.controls.reportefalla_serie.setValue(telefono.telefono_imei);
      const movil = this.movilList.find(m => m.movil_id == telefono.movil_id);
      this.fallaForm.controls.reportefalla_descripcionequipo.setValue(
        movil ? (movil.movil_marca + ' ' + movil.movil_modelo).trim() : ''
      );
    }
  }

  sugerirResponsable() {
    const empresaId = this.trabajador.empresa_id;
    const sedeId = this.trabajador.sede_id;
    let responsable = null;

    if (empresaId == EMPRESA_ID_ITURRI_AP) {
      responsable = 'William Flores';
    } else if (empresaId == EMPRESA_ID_ITURRI_AC) {
      responsable = 'Leonardo Rivas';
    } else if (empresaId == EMPRESA_ID_SMARTBOTS) {
      responsable = 'Manuel Oberto';
    } else if (empresaId == EMPRESA_ID_CHAVIMOCHIC) {
      responsable = SEDE_RESPONSABLE_CHAVIMOCHIC[sedeId] || null;
    }

    this.fallaForm.controls.reportefalla_responsable.setValue(responsable);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  guardar() {
    if (this.fallaForm.invalid || this.guardando) {
      this.fallaForm.markAllAsTouched();
      return;
    }
    this.guardando = true;
    const objEnvio = this.fallaForm.getRawValue();
    objEnvio.trabajador_id = this.trabajador.trabajador_id;

    this.reportefallaService.registrar(objEnvio).then(async (response: CommonResponse) => {
      this.guardando = false;
      if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
        this.toastService.success(response.mensajes);
        this.dialogRef.close(1);
      } else {
        this.toastService.error(response.mensajes);
      }
    });
  }

}
